/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_scatter_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A rising cloud of points indicates a positive correlation.`)
};

const es_scatter_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una nube de puntos ascendente indica una correlación positiva.`)
};

const de_scatter_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine ansteigende Punktwolke deutet auf eine positive Korrelation hin.`)
};

const nl_scatter_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een stijgende puntenwolk duidt op een positieve correlatie.`)
};

const fr_scatter_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un nuage de points ascendant indique une corrélation positive.`)
};

const it_scatter_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una nuvola di punti crescente indica una correlazione positiva.`)
};

const pt_br2_scatter_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma nuvem de pontos ascendente indica correlação positiva.`)
};

const pt_scatter_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma nuvem de pontos ascendente indica uma correlação positiva.`)
};

const ja_scatter_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`右肩上がりの点群は正の相関を示します。`)
};

const zh_scatter_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上升的点云表示正相关。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const scatter_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.scatter_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("scatter_ex2", locale)
	if (locale === "en") return en_scatter_ex2(inputs)
	if (locale === "es") return es_scatter_ex2(inputs)
	if (locale === "de") return de_scatter_ex2(inputs)
	if (locale === "nl") return nl_scatter_ex2(inputs)
	if (locale === "fr") return fr_scatter_ex2(inputs)
	if (locale === "it") return it_scatter_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_scatter_ex2(inputs)
	if (locale === "pt") return pt_scatter_ex2(inputs)
	if (locale === "ja") return ja_scatter_ex2(inputs)
	return zh_scatter_ex2(inputs)
};